import { MenuProps as MenuPropsType } from "@mui/material/Menu";

export interface State {
  isRPPanelOpened: boolean;
  isDeleteRpDialogOpened: boolean;
  isDeleteRtDialogOpened: boolean;
  rateplanData: any;
  rpToDelete: any;
  rtToDelete: any;
  isRPPanelNew: boolean;
  roomData: any;
  isRTPanelOpened: boolean;
  isRTPanelNew: boolean;
  unEditable: boolean;
  unEditableRP: boolean;
  isOverflow: boolean[];
  isOverflowRT: boolean[];
  ratePlanArray: any;
  roomTypeData: any;
  counter: number;
  searchInput: any;
  searchDropDown: any;
  isDraging: boolean;
  rtUpdatedStatus: boolean;
  rpUpdatedStatus: boolean;
  previousLocation: string;
  key: number;
  setRateFilter: string;
  searchModeOfSale: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps: Partial<MenuPropsType> = {
  variant: "menu",
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "inherit",
    },
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
};

export { MenuProps };
